var _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgApiBind(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "API_Bind",
    "data-name": "API Bind",
    xmlns: "http://www.w3.org/2000/svg",
    width: 32.03,
    height: 35.114,
    viewBox: "0 0 32.03 35.114",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_16",
    "data-name": "Group 16"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_14",
    "data-name": "Path 14",
    d: "M125.927,204H111.575a1.115,1.115,0,0,0,0,2.229h14.352a1.115,1.115,0,0,0,0-2.229Z",
    transform: "translate(-104.894 -190.066)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15",
    "data-name": "Path 15",
    d: "M120.291,284h-8.717a1.115,1.115,0,0,0,0,2.229h8.717a1.115,1.115,0,0,0,0-2.229Z",
    transform: "translate(-104.894 -264.492)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16",
    "data-name": "Path 16",
    d: "M53,4H35.865a5.3,5.3,0,0,0-5.3,5.3V33.819a5.3,5.3,0,0,0,5.3,5.3h4.66a1.115,1.115,0,0,0,0-2.229h-4.66A3.069,3.069,0,0,1,32.8,33.819V9.3a3.069,3.069,0,0,1,3.066-3.066H53A3.069,3.069,0,0,1,56.062,9.3v8.57a1.115,1.115,0,1,0,2.229,0V9.3A5.3,5.3,0,0,0,53,4Z",
    transform: "translate(-30.57 -4)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17",
    "data-name": "Path 17",
    d: "M125.927,124H111.575a1.115,1.115,0,0,0,0,2.229h14.352a1.115,1.115,0,0,0,0-2.229Z",
    transform: "translate(-104.894 -115.639)",
    fill: "#fff"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_21",
    "data-name": "Group 21",
    transform: "translate(12.822 15.885)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_18",
    "data-name": "Group 18",
    transform: "translate(0 6.176)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_17",
    "data-name": "Group 17"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_18",
    "data-name": "Path 18",
    d: "M226.33,321.952a4.332,4.332,0,0,0-.752-.6,4.483,4.483,0,0,0-5.586.605l-4.072,4.075a4.481,4.481,0,0,0,6.335,6.341l3.361-3.361a.32.32,0,0,0-.227-.548h-.128a5.375,5.375,0,0,1-2.048-.4.32.32,0,0,0-.349.07l-2.417,2.42a1.922,1.922,0,0,1-2.718-2.718l4.088-4.085a1.92,1.92,0,0,1,2.714,0,1.312,1.312,0,0,0,1.8,0,1.269,1.269,0,0,0,0-1.8Z",
    transform: "translate(-214.61 -320.64)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_20",
    "data-name": "Group 20",
    transform: "translate(7.109 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_19",
    "data-name": "Group 19"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_19",
    "data-name": "Path 19",
    d: "M327.428,233.313a4.482,4.482,0,0,0-6.338,0l-3.358,3.355a.321.321,0,0,0,.234.547h.118a5.376,5.376,0,0,1,2.046.4.32.32,0,0,0,.349-.07l2.411-2.407a1.922,1.922,0,0,1,2.718,2.718l-3,3-.026.029-1.05,1.044a1.92,1.92,0,0,1-2.714,0,1.312,1.312,0,0,0-1.8,0,1.276,1.276,0,0,0,0,1.805,4.432,4.432,0,0,0,1.281.9c.067.032.134.058.2.086s.138.051.2.077.138.048.2.067l.189.051c.128.032.256.058.387.08a4.365,4.365,0,0,0,.477.045h.244l.192-.022c.07,0,.144-.02.227-.02h.109l.221-.032.1-.019.185-.038h.036a4.478,4.478,0,0,0,2.078-1.178l4.075-4.075A4.48,4.48,0,0,0,327.428,233.313Z",
    transform: "translate(-316.642 -232)",
    fill: "#fff"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApiBind);
export default __webpack_public_path__ + "static/media/api_bind.53deeae4d8a7a35c1956bb80f02ca401.svg";
export { ForwardRef as ReactComponent };